import CustomerCareKeys from '../../locales/keys';
export var ALL_STEPS_KEYS = [CustomerCareKeys.WIZARD.STEPS.OFFERS, CustomerCareKeys.WIZARD.STEPS.COMPARE_OFFERS, CustomerCareKeys.WIZARD.STEPS.DECISIONS, CustomerCareKeys.WIZARD.STEPS.ATTRIBUTES, CustomerCareKeys.WIZARD.STEPS.CHECKOUT];
export var TransitionActions = {
  NONE: 0,
  ADD: 1,
  MODIFY: 2,
  TRANSITION: 3,
  REMOVE: 4,
  TRANSITION_REQUEST: 5
};
export var TransitionStates = {
  ADDED: 1,
  REMOVED: 2,
  CHANGED: 3,
  NO_CHANGE: 4
};
export var TRANSITION_OFFER = 'TRANSITION_OFFER';
export var RemoveOfferReasonCodes = {
  DefaultedToRemove: 0
};
export var STATE_OR_NAME = 'index.customercare.customer.orders.transition';